import { Injectable } from '@angular/core';
import { CrudService } from '@appstrax/services/database';
import { PhoneCallRecord } from '@models';

@Injectable({ providedIn: 'root' })
export class PhoneCallRecordService extends CrudService<PhoneCallRecord> {
  constructor() {
    super('phone-call-records', PhoneCallRecord);
  }
}

